export default __webpack_public_path__ + "static/media/spinner2.135af58d.svg";